var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-outline",
    { attrs: { title: _vm.$t("administration.company_add") } },
    [
      _c(
        "template",
        { slot: "pageContent" },
        [
          _c(
            "b-row",
            { staticClass: "pb-3 no-gutters" },
            [
              _c("back-button", {
                staticClass: "btnFilter_2",
                attrs: { returnUrl: _vm.returnUrl },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _vm.companyOptions.length
            ? _c(
                "form-accordion",
                {
                  attrs: {
                    title: _vm.$t("mandate.parent_node"),
                    isTitleUpperCase: false,
                  },
                },
                [
                  _c(
                    "b-row",
                    { staticClass: "ml-2 mr-2" },
                    [
                      _c(
                        "b-col",
                        { staticClass: "form-group", attrs: { sm: "6" } },
                        [
                          _c("label", [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.$t("mandate.parent_node")) +
                                "\n              "
                            ),
                            _c(
                              "span",
                              {
                                staticClass: "color-red",
                                attrs: { "aria-hidden": "true" },
                              },
                              [_vm._v("*")]
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.selectedCompany,
                                  expression: "selectedCompany",
                                },
                              ],
                              staticClass: "form-control",
                              attrs: { id: "parent-node" },
                              on: {
                                change: function ($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function (o) {
                                      return o.selected
                                    })
                                    .map(function (o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.selectedCompany = $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                },
                              },
                            },
                            [
                              _c(
                                "option",
                                {
                                  attrs: { disabled: "" },
                                  domProps: { value: null },
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.$t("mandate.parent_node")) +
                                      "\n              "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _vm._l(_vm.companyOptions, function (company) {
                                return _c(
                                  "option",
                                  {
                                    key: company.value,
                                    domProps: { value: company.value },
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(company.text) +
                                        "\n              "
                                    ),
                                  ]
                                )
                              }),
                            ],
                            2
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.selectedCompany !== null || !_vm.companyOptions.length
            ? _c(
                "div",
                [
                  _c("br"),
                  _vm._v(" "),
                  _c("hr", { staticClass: "mx-auto" }),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c(
                    "form-accordion",
                    {
                      attrs: {
                        title: _vm.$t("administration.company"),
                        isTitleUpperCase: false,
                      },
                    },
                    [
                      _c("div", { staticClass: "form-group" }),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        { staticClass: "ml-2 mr-2" },
                        [
                          _c(
                            "b-col",
                            { staticClass: "form-group", attrs: { sm: "6" } },
                            [
                              _c("form-write-group-label-input", {
                                attrs: {
                                  isMandatory: "",
                                  inputLabel: _vm.$t(
                                    "administration.identifier"
                                  ),
                                  placeholderValue: _vm.$t(
                                    "administration.identifier"
                                  ),
                                },
                                model: {
                                  value: _vm.identifier,
                                  callback: function ($$v) {
                                    _vm.identifier = $$v
                                  },
                                  expression: "identifier",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { staticClass: "form-group", attrs: { sm: "6" } },
                            [
                              _c("form-write-group-label-input", {
                                attrs: {
                                  isMandatory: "",
                                  inputLabel: _vm.$t(
                                    "administration.company_name"
                                  ),
                                  placeholderValue: _vm.$t(
                                    "administration.company_name"
                                  ),
                                },
                                model: {
                                  value: _vm.name,
                                  callback: function ($$v) {
                                    _vm.name = $$v
                                  },
                                  expression: "name",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        { staticClass: "ml-2 mr-2" },
                        [
                          _c(
                            "b-col",
                            { staticClass: "form-group", attrs: { sm: "6" } },
                            [
                              _c("form-write-group-label-input", {
                                attrs: {
                                  inputLabel: _vm.$t(
                                    "administration.user_email"
                                  ),
                                  placeholderValue: _vm.$t(
                                    "administration.user_email"
                                  ),
                                },
                                model: {
                                  value: _vm.email_reference,
                                  callback: function ($$v) {
                                    _vm.email_reference = $$v
                                  },
                                  expression: "email_reference",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { staticClass: "form-group", attrs: { sm: "6" } },
                            [
                              _c("label", [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.$t("administration.active")) +
                                    "\n              "
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.active,
                                      expression: "active",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  attrs: { id: "sel4", readonly: "" },
                                  on: {
                                    change: function ($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call(
                                          $event.target.options,
                                          function (o) {
                                            return o.selected
                                          }
                                        )
                                        .map(function (o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.active = $event.target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    },
                                  },
                                },
                                [
                                  _c("option", { attrs: { value: "0" } }, [
                                    _vm._v(_vm._s(_vm.$t("administration.no"))),
                                  ]),
                                  _vm._v(" "),
                                  _c("option", { attrs: { value: "1" } }, [
                                    _vm._v(
                                      _vm._s(_vm.$t("administration.in_prgrss"))
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("option", { attrs: { value: "2" } }, [
                                    _vm._v(
                                      _vm._s(_vm.$t("administration.yes"))
                                    ),
                                  ]),
                                ]
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        { staticClass: "ml-2 mr-2" },
                        [
                          _c(
                            "b-col",
                            { staticClass: "form-group", attrs: { sm: "6" } },
                            [
                              _c("form-write-group-label-input", {
                                attrs: {
                                  isMandatory: "",
                                  inputLabel: _vm.$t("administration.address"),
                                  placeholderValue: _vm.$t(
                                    "administration.address"
                                  ),
                                },
                                model: {
                                  value: _vm.address,
                                  callback: function ($$v) {
                                    _vm.address = $$v
                                  },
                                  expression: "address",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { staticClass: "form-group", attrs: { sm: "6" } },
                            [
                              _c("form-write-group-label-input", {
                                attrs: {
                                  isMandatory: "",
                                  inputLabel: _vm.$t("administration.city"),
                                  placeholderValue: _vm.$t(
                                    "administration.city"
                                  ),
                                },
                                model: {
                                  value: _vm.city,
                                  callback: function ($$v) {
                                    _vm.city = $$v
                                  },
                                  expression: "city",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { staticClass: "form-group", attrs: { sm: "6" } },
                            [
                              _c("form-write-group-label-input", {
                                attrs: {
                                  isMandatory: "",
                                  inputLabel: _vm.$t("administration.zip_code"),
                                  placeholderValue: _vm.$t(
                                    "administration.zip_code"
                                  ),
                                },
                                model: {
                                  value: _vm.zip_code,
                                  callback: function ($$v) {
                                    _vm.zip_code = $$v
                                  },
                                  expression: "zip_code",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { staticClass: "form-group", attrs: { sm: "6" } },
                            [
                              _c(
                                "form-write-group-label-input",
                                {
                                  attrs: {
                                    isMandatory: "",
                                    inputType: "listeSelect",
                                    inputLabel: _vm.$t(
                                      "administration.country"
                                    ),
                                  },
                                },
                                [
                                  _c(
                                    "select",
                                    {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.country,
                                          expression: "country",
                                        },
                                      ],
                                      staticClass: "form-control",
                                      on: {
                                        change: function ($event) {
                                          var $$selectedVal =
                                            Array.prototype.filter
                                              .call(
                                                $event.target.options,
                                                function (o) {
                                                  return o.selected
                                                }
                                              )
                                              .map(function (o) {
                                                var val =
                                                  "_value" in o
                                                    ? o._value
                                                    : o.value
                                                return val
                                              })
                                          _vm.country = $event.target.multiple
                                            ? $$selectedVal
                                            : $$selectedVal[0]
                                        },
                                      },
                                    },
                                    _vm._l(_vm.countryOptions, function (opt) {
                                      return _c(
                                        "option",
                                        {
                                          key: opt.iso2,
                                          domProps: { value: opt.iso2 },
                                        },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(
                                                _vm.$t("countries." + opt.key)
                                              ) +
                                              "\n                  "
                                          ),
                                        ]
                                      )
                                    }),
                                    0
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  false
                    ? _c(
                        "form-accordion",
                        {
                          attrs: {
                            title: _vm.$t("administration.user"),
                            isTitleUpperCase: false,
                            open: false,
                          },
                        },
                        [
                          _c("div", { staticClass: "form-group" }),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            { staticClass: "ml-2 mr-2" },
                            [
                              _c(
                                "b-col",
                                {
                                  staticClass: "form-group",
                                  attrs: { sm: "6" },
                                },
                                [
                                  _c("form-write-group-label-input", {
                                    attrs: {
                                      isMandatory: "",
                                      inputLabel: _vm.$t(
                                        "administration.login"
                                      ),
                                      placeholderValue: _vm.$t(
                                        "administration.login"
                                      ),
                                    },
                                    model: {
                                      value: _vm.login,
                                      callback: function ($$v) {
                                        _vm.login = $$v
                                      },
                                      expression: "login",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                {
                                  staticClass: "form-group",
                                  attrs: { sm: "6" },
                                },
                                [
                                  _c("form-write-group-label-input", {
                                    attrs: {
                                      isMandatory: "",
                                      inputLabel: _vm.$t(
                                        "administration.username"
                                      ),
                                      placeholderValue: _vm.$t(
                                        "administration.username"
                                      ),
                                    },
                                    model: {
                                      value: _vm.username,
                                      callback: function ($$v) {
                                        _vm.username = $$v
                                      },
                                      expression: "username",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            { staticClass: "ml-2 mr-2" },
                            [
                              _c(
                                "b-col",
                                {
                                  staticClass: "form-group",
                                  attrs: { sm: "6" },
                                },
                                [
                                  _c("label", [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.$t("administration.active")
                                        ) +
                                        "\n              "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "select",
                                    {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.active_user,
                                          expression: "active_user",
                                        },
                                      ],
                                      staticClass: "form-control",
                                      attrs: { id: "sel4", readonly: "" },
                                      on: {
                                        change: function ($event) {
                                          var $$selectedVal =
                                            Array.prototype.filter
                                              .call(
                                                $event.target.options,
                                                function (o) {
                                                  return o.selected
                                                }
                                              )
                                              .map(function (o) {
                                                var val =
                                                  "_value" in o
                                                    ? o._value
                                                    : o.value
                                                return val
                                              })
                                          _vm.active_user = $event.target
                                            .multiple
                                            ? $$selectedVal
                                            : $$selectedVal[0]
                                        },
                                      },
                                    },
                                    [
                                      _c("option", { attrs: { value: "0" } }, [
                                        _vm._v(
                                          _vm._s(_vm.$t("administration.no"))
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("option", { attrs: { value: "1" } }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("administration.in_prgrss")
                                          )
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("option", { attrs: { value: "2" } }, [
                                        _vm._v(
                                          _vm._s(_vm.$t("administration.yes"))
                                        ),
                                      ]),
                                    ]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                {
                                  staticClass: "form-group",
                                  attrs: { sm: "6" },
                                },
                                [
                                  _c("form-write-group-label-input", {
                                    attrs: {
                                      inputLabel: _vm.$t(
                                        "administration.password"
                                      ),
                                      inputType: "password",
                                      placeholderValue: _vm.$t(
                                        "administration.password"
                                      ),
                                    },
                                    model: {
                                      value: _vm.password,
                                      callback: function ($$v) {
                                        _vm.password = $$v
                                      },
                                      expression: "password",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  false
                    ? _c(
                        "form-accordion",
                        {
                          attrs: {
                            title: _vm.$t("administration.right"),
                            isTitleUpperCase: false,
                            open: false,
                          },
                        },
                        [
                          _c("div", { staticClass: "form-group" }),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            { staticClass: "ml-2 mr-2" },
                            _vm._l(_vm.rights, function (result, id) {
                              return _c(
                                "b-col",
                                {
                                  key: result + "-" + id,
                                  staticClass: "form-group",
                                  attrs: { sm: "6", lg: "4", xl: "3" },
                                },
                                [
                                  _c(
                                    "b-form-checkbox",
                                    {
                                      attrs: { value: result },
                                      model: {
                                        value: _vm.select_rights,
                                        callback: function ($$v) {
                                          _vm.select_rights = $$v
                                        },
                                        expression: "select_rights",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.$t(
                                              "rights.db_rights." + result
                                            ) ===
                                              "rights.db_rights." + result
                                              ? result
                                              : _vm.$t(
                                                  "rights.db_rights." + result
                                                )
                                          ) +
                                          "\n              "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("hr", { staticClass: "mx-auto" }),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c(
                    "form-accordion",
                    {
                      attrs: {
                        title: _vm.$t("administration.company_prfls"),
                        isTitleUpperCase: false,
                      },
                    },
                    [
                      _c(
                        "b-col",
                        {
                          staticClass: "no-gutter px-0 ml-2 mr-2",
                          attrs: { cols: "3" },
                        },
                        [
                          _c("label", [_vm._v("Roles")]),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              staticClass:
                                "combo-list-field d-flex justify-content-between",
                              attrs: {
                                id: "profile-picker-link-default",
                                href: "#",
                              },
                            },
                            [
                              _c(
                                "span",
                                {
                                  class:
                                    "fixed-span-size " +
                                    (_vm.profileDisplay.nb > 0
                                      ? "filter-item-input-complete"
                                      : ""),
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.profileDisplay.label) +
                                      "\n              "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("i", {
                                staticClass: "fa-light fa-chevron-down",
                                attrs: { size: "17px", id: "status-chevron" },
                              }),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-popover",
                            {
                              attrs: {
                                target: "profile-picker-link-default",
                                title: _vm.$t("administration.select_profile"),
                                triggers: "focus",
                                placement: "bottom",
                              },
                            },
                            _vm._l(_vm.templates, function (profile, index) {
                              return _c(
                                "span",
                                {
                                  key:
                                    "filtered-profile-" +
                                    profile.name_template +
                                    "-" +
                                    index,
                                },
                                [
                                  _c(
                                    "b-form-checkbox",
                                    {
                                      attrs: { value: 1, "unchecked-value": 0 },
                                      model: {
                                        value: profile.active,
                                        callback: function ($$v) {
                                          _vm.$set(profile, "active", $$v)
                                        },
                                        expression: "profile.active",
                                      },
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(_vm._s(profile.label)),
                                      ]),
                                    ]
                                  ),
                                ],
                                1
                              )
                            }),
                            0
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("hr", { staticClass: "mx-auto" }),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c(
                    "form-accordion",
                    {
                      attrs: {
                        title: _vm.$t("mandate.technical_access.title"),
                        isTitleUpperCase: false,
                      },
                    },
                    [
                      _c(
                        "b-form-checkbox",
                        {
                          model: {
                            value: _vm.technicalUser,
                            callback: function ($$v) {
                              _vm.technicalUser = $$v
                            },
                            expression: "technicalUser",
                          },
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t("mandate.technical_access.technical_user")
                            )
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _vm.technicalUser
                        ? _c(
                            "b-col",
                            { staticClass: "px-0 mt-3", attrs: { cols: "12" } },
                            [
                              _c(
                                "form-accordion",
                                {
                                  attrs: {
                                    title: _vm.$t("common.security.certificat"),
                                    isTitleUpperCase: false,
                                  },
                                },
                                [
                                  _c(
                                    "b-row",
                                    { staticClass: "d-flex form-group" },
                                    [
                                      _c(
                                        "b-col",
                                        {
                                          staticClass: "form-group",
                                          attrs: { sm: "6" },
                                        },
                                        [
                                          _c("form-write-group-label-input", {
                                            attrs: {
                                              isMandatory: "",
                                              inputLabel: _vm.$t(
                                                "common.security.name"
                                              ),
                                              placeholderValue: _vm.$t(
                                                "common.security.name"
                                              ),
                                            },
                                            model: {
                                              value: _vm.form.name,
                                              callback: function ($$v) {
                                                _vm.$set(_vm.form, "name", $$v)
                                              },
                                              expression: "form.name",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _vm.certificateText !== "" ||
                                  _vm.form.stateCertificat === 0
                                    ? _c(
                                        "b-row",
                                        {
                                          staticClass:
                                            "d-flex justify-content-center align-items-center form-group",
                                        },
                                        [
                                          _c(
                                            "b-col",
                                            {
                                              staticClass: "form-group",
                                              attrs: {
                                                sm:
                                                  _vm.certificateText === ""
                                                    ? 6
                                                    : 12,
                                              },
                                            },
                                            [
                                              _c(
                                                "label",
                                                {
                                                  attrs: {
                                                    for: "certificate-content",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "common.security.certificat_file_content"
                                                        )
                                                      ) +
                                                      "\n                    "
                                                  ),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass: "color-red",
                                                      attrs: {
                                                        "aria-hidden": "true",
                                                      },
                                                    },
                                                    [_vm._v("*")]
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("b-form-textarea", {
                                                staticStyle: {
                                                  "max-height": "none",
                                                },
                                                attrs: {
                                                  id: "certificate-content",
                                                  required: "",
                                                  placeholder: _vm.$t(
                                                    "common.security.enter_something"
                                                  ),
                                                  rows: "6",
                                                },
                                                on: {
                                                  input: _vm.processCertificat,
                                                },
                                                model: {
                                                  value: _vm.certificateText,
                                                  callback: function ($$v) {
                                                    _vm.certificateText = $$v
                                                  },
                                                  expression: "certificateText",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _vm.certificateText === "" &&
                                          _vm.form.stateCertificat === 0
                                            ? _c(
                                                "b-col",
                                                {
                                                  staticClass:
                                                    "form-group d-flex flex-column",
                                                  attrs: { sm: "6" },
                                                },
                                                [
                                                  _c(
                                                    "label",
                                                    {
                                                      attrs: {
                                                        for: "certificate-file",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                    " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "common.security.certificat_file"
                                                            )
                                                          ) +
                                                          "\n                  "
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("input", {
                                                    attrs: {
                                                      id: "certificate-file",
                                                      type: "file",
                                                      accept: ".pem,.crt",
                                                    },
                                                    on: {
                                                      change:
                                                        _vm.handleFileUploadCertificat,
                                                    },
                                                  }),
                                                ]
                                              )
                                            : _vm._e(),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "b-row",
                                    {
                                      staticClass:
                                        "d-flex align-items-center form-group",
                                    },
                                    [
                                      _c(
                                        "b-col",
                                        {
                                          staticClass: "form-group normal-font",
                                          attrs: { sm: "6" },
                                        },
                                        [
                                          _c("form-read-group-label-input", {
                                            attrs: {
                                              inputValue: _vm.form.startDate,
                                              inputLabel: _vm.$t(
                                                "common.security.startDate"
                                              ),
                                              placeholderValue: _vm.$t(
                                                "common.security.startDate"
                                              ),
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-col",
                                        {
                                          staticClass: "form-group normal-font",
                                          attrs: { sm: "6" },
                                        },
                                        [
                                          _c("form-read-group-label-input", {
                                            attrs: {
                                              inputValue: _vm.form.endDate,
                                              inputLabel: _vm.$t(
                                                "common.security.endDate"
                                              ),
                                              placeholderValue: _vm.$t(
                                                "common.security.endDate"
                                              ),
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-row",
                                    {
                                      staticClass:
                                        "d-flex align-items-center form-group",
                                    },
                                    [
                                      _c(
                                        "b-col",
                                        {
                                          staticClass: "form-group normal-font",
                                          attrs: { sm: "6" },
                                        },
                                        [
                                          _c("form-read-group-label-input", {
                                            attrs: {
                                              inputValue: _vm.form.deliveredBy,
                                              inputLabel: _vm.$t(
                                                "common.security.deliveredBy"
                                              ),
                                              placeholderValue: _vm.$t(
                                                "common.security.deliveredBy"
                                              ),
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-col",
                                        {
                                          staticClass: "form-group normal-font",
                                          attrs: { sm: "6" },
                                        },
                                        [
                                          _c("form-read-group-label-input", {
                                            attrs: {
                                              inputValue: _vm.form.deliveredTo,
                                              inputLabel: _vm.$t(
                                                "common.security.deliveredTo"
                                              ),
                                              placeholderValue: _vm.$t(
                                                "common.security.deliveredTo"
                                              ),
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("br"),
                              _vm._v(" "),
                              _c("hr", { staticClass: "mx-auto" }),
                              _vm._v(" "),
                              _c("br"),
                              _vm._v(" "),
                              _c(
                                "form-accordion",
                                {
                                  attrs: {
                                    title: _vm.$t(
                                      "common.security.private_key"
                                    ),
                                    isTitleUpperCase: false,
                                  },
                                },
                                [
                                  _vm.form.statePrivateKey === 0
                                    ? _c(
                                        "b-row",
                                        {
                                          staticClass:
                                            "d-flex justify-content-center align-items-center form-group",
                                        },
                                        [
                                          _c(
                                            "b-col",
                                            {
                                              staticClass: "form-group",
                                              attrs: {
                                                sm:
                                                  _vm.privateKeyText === ""
                                                    ? 6
                                                    : 12,
                                              },
                                            },
                                            [
                                              _c(
                                                "label",
                                                {
                                                  attrs: {
                                                    for: "private-key-content",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "common.security.private_key_file_content"
                                                        )
                                                      ) +
                                                      "\n                    "
                                                  ),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass: "color-red",
                                                      attrs: {
                                                        "aria-hidden": "true",
                                                      },
                                                    },
                                                    [_vm._v("*")]
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("b-form-textarea", {
                                                staticStyle: {
                                                  "max-height": "none",
                                                },
                                                attrs: {
                                                  id: "private-key-content",
                                                  required: "",
                                                  placeholder: _vm.$t(
                                                    "common.security.enter_something"
                                                  ),
                                                  rows: "6",
                                                },
                                                on: {
                                                  input: _vm.processPrivateKey,
                                                },
                                                model: {
                                                  value: _vm.privateKeyText,
                                                  callback: function ($$v) {
                                                    _vm.privateKeyText = $$v
                                                  },
                                                  expression: "privateKeyText",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _vm.privateKeyText === ""
                                            ? _c(
                                                "b-col",
                                                {
                                                  staticClass:
                                                    "form-group d-flex flex-column",
                                                  attrs: { sm: "6" },
                                                },
                                                [
                                                  _c(
                                                    "label",
                                                    {
                                                      attrs: {
                                                        for: "private-key-file",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                    " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "common.security.private_key_file"
                                                            )
                                                          ) +
                                                          "\n                  "
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("input", {
                                                    attrs: {
                                                      id: "private-key-file",
                                                      type: "file",
                                                      accept: ".pem, .key",
                                                    },
                                                    on: {
                                                      change:
                                                        _vm.handleFileUploadPrivateKey,
                                                    },
                                                  }),
                                                ]
                                              )
                                            : _vm._e(),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "b-row",
                                    {
                                      staticClass:
                                        "d-flex justify-content-center align-items-center form-group",
                                    },
                                    [
                                      _c(
                                        "b-col",
                                        {
                                          staticClass: "form-group",
                                          attrs: { sm: "6" },
                                        },
                                        [
                                          _c("form-write-group-label-input", {
                                            attrs: {
                                              inputLabel: _vm.$t(
                                                "common.security.password"
                                              ),
                                              placeholderValue: _vm.$t(
                                                "common.security.password"
                                              ),
                                            },
                                            model: {
                                              value: _vm.form.password,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "password",
                                                  $$v
                                                )
                                              },
                                              expression: "form.password",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("b-col", {
                                        staticClass: "form-group",
                                        attrs: { sm: "6" },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "form-accordion",
                    {
                      attrs: {
                        open: "",
                        title: _vm.$t(
                          "mandate.remittance_generation.parameter"
                        ),
                      },
                    },
                    [
                      _c(
                        "form-accordion",
                        {
                          attrs: {
                            open: "",
                            title: _vm.$t(
                              "mandate.remittance_generation.sdd_remittance_generation"
                            ),
                          },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "sdd-generation-settings" },
                            [
                              _c("div", { staticClass: "generation-row" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "custom-control custom-radio",
                                  },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.generationMode,
                                          expression: "generationMode",
                                        },
                                      ],
                                      staticClass: "custom-control-input",
                                      attrs: {
                                        id: "generationManual",
                                        type: "radio",
                                        name: "generationRadio",
                                        value: "manual",
                                        disabled: !_vm.doesEdit,
                                      },
                                      domProps: {
                                        checked: _vm._q(
                                          _vm.generationMode,
                                          "manual"
                                        ),
                                      },
                                      on: {
                                        change: function ($event) {
                                          _vm.generationMode = "manual"
                                        },
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "label",
                                      {
                                        staticClass: "custom-control-label",
                                        attrs: { for: "generationManual" },
                                      },
                                      [
                                        _vm._v(
                                          "\n                      " +
                                            _vm._s(
                                              _vm.$t(
                                                "mandate.remittance_generation.manual_trigger"
                                              )
                                            ) +
                                            "\n                    "
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "generation-row interval-row" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "custom-control custom-radio",
                                    },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.generationMode,
                                            expression: "generationMode",
                                          },
                                        ],
                                        staticClass: "custom-control-input",
                                        attrs: {
                                          id: "generationInterval",
                                          type: "radio",
                                          name: "generationRadio",
                                          value: "auto",
                                          disabled: !_vm.doesEdit,
                                        },
                                        domProps: {
                                          checked: _vm._q(
                                            _vm.generationMode,
                                            "auto"
                                          ),
                                        },
                                        on: {
                                          change: function ($event) {
                                            _vm.generationMode = "auto"
                                          },
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "label",
                                        {
                                          staticClass: "custom-control-label",
                                          attrs: { for: "generationInterval" },
                                        },
                                        [
                                          _vm._v(
                                            "\n                      " +
                                              _vm._s(
                                                _vm.$t(
                                                  "mandate.remittance_generation.within_interval"
                                                )
                                              ) +
                                              "\n                    "
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "interval-selects" },
                                    [
                                      _c(
                                        "select",
                                        {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.generationFrequency,
                                              expression: "generationFrequency",
                                            },
                                          ],
                                          staticClass:
                                            "form-control form-control-sm",
                                          attrs: {
                                            disabled:
                                              !_vm.doesEdit ||
                                              _vm.generationMode !== "auto",
                                          },
                                          on: {
                                            change: function ($event) {
                                              var $$selectedVal =
                                                Array.prototype.filter
                                                  .call(
                                                    $event.target.options,
                                                    function (o) {
                                                      return o.selected
                                                    }
                                                  )
                                                  .map(function (o) {
                                                    var val =
                                                      "_value" in o
                                                        ? o._value
                                                        : o.value
                                                    return val
                                                  })
                                              _vm.generationFrequency = $event
                                                .target.multiple
                                                ? $$selectedVal
                                                : $$selectedVal[0]
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "option",
                                            { attrs: { value: "daily" } },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "mandate.remittance_generation.daily"
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "option",
                                            { attrs: { value: "weekly" } },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "mandate.remittance_generation.weekly"
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "select",
                                        {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.generationTime,
                                              expression: "generationTime",
                                            },
                                          ],
                                          staticClass:
                                            "form-control form-control-sm space",
                                          attrs: {
                                            disabled:
                                              !_vm.doesEdit ||
                                              _vm.generationMode !== "auto",
                                          },
                                          on: {
                                            change: function ($event) {
                                              var $$selectedVal =
                                                Array.prototype.filter
                                                  .call(
                                                    $event.target.options,
                                                    function (o) {
                                                      return o.selected
                                                    }
                                                  )
                                                  .map(function (o) {
                                                    var val =
                                                      "_value" in o
                                                        ? o._value
                                                        : o.value
                                                    return val
                                                  })
                                              _vm.generationTime = $event.target
                                                .multiple
                                                ? $$selectedVal
                                                : $$selectedVal[0]
                                            },
                                          },
                                        },
                                        _vm._l(24, function (hour) {
                                          return _c(
                                            "option",
                                            {
                                              key: hour - 1,
                                              domProps: {
                                                value:
                                                  String(hour - 1).padStart(
                                                    2,
                                                    "0"
                                                  ) +
                                                  "-" +
                                                  String(hour % 24).padStart(
                                                    2,
                                                    "0"
                                                  ),
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                        " +
                                                  _vm._s(hour - 1) +
                                                  "h - " +
                                                  _vm._s(hour % 24) +
                                                  "h\n                      "
                                              ),
                                            ]
                                          )
                                        }),
                                        0
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "form-accordion",
                        {
                          attrs: {
                            open: "",
                            title: _vm.$t(
                              "mandate.remittance_generation.sdd_remittance_file_generation"
                            ),
                          },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "sdd-generation-settings" },
                            [
                              _c("div", { staticClass: "generation-row" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "custom-control custom-radio",
                                  },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.generationModeSDD,
                                          expression: "generationModeSDD",
                                        },
                                      ],
                                      staticClass: "custom-control-input",
                                      attrs: {
                                        id: "sddgenerationManual",
                                        type: "radio",
                                        name: "sddgenerationRadio",
                                        value: "manual",
                                        disabled: !_vm.doesEdit,
                                      },
                                      domProps: {
                                        checked: _vm._q(
                                          _vm.generationModeSDD,
                                          "manual"
                                        ),
                                      },
                                      on: {
                                        change: function ($event) {
                                          _vm.generationModeSDD = "manual"
                                        },
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "label",
                                      {
                                        staticClass: "custom-control-label",
                                        attrs: { for: "sddgenerationManual" },
                                      },
                                      [
                                        _vm._v(
                                          "\n                      " +
                                            _vm._s(
                                              _vm.$t(
                                                "mandate.remittance_generation.manual_trigger"
                                              )
                                            ) +
                                            "\n                    "
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "generation-row interval-row" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "custom-control custom-radio",
                                    },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.generationModeSDD,
                                            expression: "generationModeSDD",
                                          },
                                        ],
                                        staticClass: "custom-control-input",
                                        attrs: {
                                          id: "sddgenerationInterval",
                                          type: "radio",
                                          name: "sddgenerationRadio",
                                          value: "auto",
                                          disabled: !_vm.doesEdit,
                                        },
                                        domProps: {
                                          checked: _vm._q(
                                            _vm.generationModeSDD,
                                            "auto"
                                          ),
                                        },
                                        on: {
                                          change: function ($event) {
                                            _vm.generationModeSDD = "auto"
                                          },
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "label",
                                        {
                                          staticClass: "custom-control-label",
                                          attrs: {
                                            for: "sddgenerationInterval",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                      " +
                                              _vm._s(
                                                _vm.$t(
                                                  "mandate.remittance_generation.within_interval"
                                                )
                                              ) +
                                              "\n                    "
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "interval-selects" },
                                    [
                                      _c(
                                        "select",
                                        {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.generationFrequencySDD,
                                              expression:
                                                "generationFrequencySDD",
                                            },
                                          ],
                                          staticClass:
                                            "form-control form-control-sm",
                                          attrs: {
                                            disabled:
                                              !_vm.doesEdit ||
                                              _vm.generationModeSDD !== "auto",
                                          },
                                          on: {
                                            change: function ($event) {
                                              var $$selectedVal =
                                                Array.prototype.filter
                                                  .call(
                                                    $event.target.options,
                                                    function (o) {
                                                      return o.selected
                                                    }
                                                  )
                                                  .map(function (o) {
                                                    var val =
                                                      "_value" in o
                                                        ? o._value
                                                        : o.value
                                                    return val
                                                  })
                                              _vm.generationFrequencySDD =
                                                $event.target.multiple
                                                  ? $$selectedVal
                                                  : $$selectedVal[0]
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "option",
                                            { attrs: { value: "daily" } },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "mandate.remittance_generation.daily"
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "option",
                                            { attrs: { value: "weekly" } },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "mandate.remittance_generation.weekly"
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "select",
                                        {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.generationTimeSDD,
                                              expression: "generationTimeSDD",
                                            },
                                          ],
                                          staticClass:
                                            "form-control form-control-sm space",
                                          attrs: {
                                            disabled:
                                              !_vm.doesEdit ||
                                              _vm.generationModeSDD !== "auto",
                                          },
                                          on: {
                                            change: function ($event) {
                                              var $$selectedVal =
                                                Array.prototype.filter
                                                  .call(
                                                    $event.target.options,
                                                    function (o) {
                                                      return o.selected
                                                    }
                                                  )
                                                  .map(function (o) {
                                                    var val =
                                                      "_value" in o
                                                        ? o._value
                                                        : o.value
                                                    return val
                                                  })
                                              _vm.generationTimeSDD = $event
                                                .target.multiple
                                                ? $$selectedVal
                                                : $$selectedVal[0]
                                            },
                                          },
                                        },
                                        _vm._l(24, function (hour) {
                                          return _c(
                                            "option",
                                            {
                                              key: "sdd-" + (hour - 1),
                                              domProps: {
                                                value:
                                                  String(hour - 1).padStart(
                                                    2,
                                                    "0"
                                                  ) +
                                                  "-" +
                                                  String(hour % 24).padStart(
                                                    2,
                                                    "0"
                                                  ),
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                        " +
                                                  _vm._s(hour - 1) +
                                                  "h - " +
                                                  _vm._s(hour % 24) +
                                                  "h\n                      "
                                              ),
                                            ]
                                          )
                                        }),
                                        0
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "form-accordion",
                        {
                          attrs: {
                            open: "",
                            title: _vm.$t(
                              "mandate.remittance_generation.sct_remittance_generation"
                            ),
                          },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "sct-generation-settings" },
                            [
                              _c("div", { staticClass: "generation-row" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "custom-control custom-radio",
                                  },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.sctGenerationMode,
                                          expression: "sctGenerationMode",
                                        },
                                      ],
                                      staticClass: "custom-control-input",
                                      attrs: {
                                        id: "sctGenerationManual",
                                        type: "radio",
                                        name: "sctGenerationRadio",
                                        value: "manual",
                                        disabled: !_vm.doesEdit,
                                      },
                                      domProps: {
                                        checked: _vm._q(
                                          _vm.sctGenerationMode,
                                          "manual"
                                        ),
                                      },
                                      on: {
                                        change: function ($event) {
                                          _vm.sctGenerationMode = "manual"
                                        },
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "label",
                                      {
                                        staticClass: "custom-control-label",
                                        attrs: { for: "sctGenerationManual" },
                                      },
                                      [
                                        _vm._v(
                                          "\n                      " +
                                            _vm._s(
                                              _vm.$t(
                                                "mandate.remittance_generation.manual_trigger"
                                              )
                                            ) +
                                            "\n                    "
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "generation-row interval-row" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "custom-control custom-radio",
                                    },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.sctGenerationMode,
                                            expression: "sctGenerationMode",
                                          },
                                        ],
                                        staticClass: "custom-control-input",
                                        attrs: {
                                          id: "sctGenerationInterval",
                                          type: "radio",
                                          name: "sctGenerationRadio",
                                          value: "auto",
                                          disabled: !_vm.doesEdit,
                                        },
                                        domProps: {
                                          checked: _vm._q(
                                            _vm.sctGenerationMode,
                                            "auto"
                                          ),
                                        },
                                        on: {
                                          change: function ($event) {
                                            _vm.sctGenerationMode = "auto"
                                          },
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "label",
                                        {
                                          staticClass: "custom-control-label",
                                          attrs: {
                                            for: "sctGenerationInterval",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                      " +
                                              _vm._s(
                                                _vm.$t(
                                                  "mandate.remittance_generation.within_interval"
                                                )
                                              ) +
                                              "\n                    "
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "interval-selects" },
                                    [
                                      _c(
                                        "select",
                                        {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.sctGenerationFrequency,
                                              expression:
                                                "sctGenerationFrequency",
                                            },
                                          ],
                                          staticClass:
                                            "form-control form-control-sm",
                                          attrs: {
                                            disabled:
                                              !_vm.doesEdit ||
                                              _vm.sctGenerationMode !== "auto",
                                          },
                                          on: {
                                            change: function ($event) {
                                              var $$selectedVal =
                                                Array.prototype.filter
                                                  .call(
                                                    $event.target.options,
                                                    function (o) {
                                                      return o.selected
                                                    }
                                                  )
                                                  .map(function (o) {
                                                    var val =
                                                      "_value" in o
                                                        ? o._value
                                                        : o.value
                                                    return val
                                                  })
                                              _vm.sctGenerationFrequency =
                                                $event.target.multiple
                                                  ? $$selectedVal
                                                  : $$selectedVal[0]
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "option",
                                            { attrs: { value: "daily" } },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "mandate.remittance_generation.daily"
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "option",
                                            { attrs: { value: "weekly" } },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "mandate.remittance_generation.weekly"
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "select",
                                        {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.sctGenerationTime,
                                              expression: "sctGenerationTime",
                                            },
                                          ],
                                          staticClass:
                                            "form-control form-control-sm space",
                                          attrs: {
                                            disabled:
                                              !_vm.doesEdit ||
                                              _vm.sctGenerationMode !== "auto",
                                          },
                                          on: {
                                            change: function ($event) {
                                              var $$selectedVal =
                                                Array.prototype.filter
                                                  .call(
                                                    $event.target.options,
                                                    function (o) {
                                                      return o.selected
                                                    }
                                                  )
                                                  .map(function (o) {
                                                    var val =
                                                      "_value" in o
                                                        ? o._value
                                                        : o.value
                                                    return val
                                                  })
                                              _vm.sctGenerationTime = $event
                                                .target.multiple
                                                ? $$selectedVal
                                                : $$selectedVal[0]
                                            },
                                          },
                                        },
                                        _vm._l(24, function (hour) {
                                          return _c(
                                            "option",
                                            {
                                              key:
                                                "sct-generation-" + (hour - 1),
                                              domProps: {
                                                value:
                                                  String(hour - 1).padStart(
                                                    2,
                                                    "0"
                                                  ) +
                                                  "-" +
                                                  String(hour % 24).padStart(
                                                    2,
                                                    "0"
                                                  ),
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                        " +
                                                  _vm._s(hour - 1) +
                                                  "h - " +
                                                  _vm._s(hour % 24) +
                                                  "h\n                      "
                                              ),
                                            ]
                                          )
                                        }),
                                        0
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "form-accordion",
                        {
                          attrs: {
                            open: "",
                            title: _vm.$t(
                              "mandate.remittance_generation.sct_remittance_file_generation"
                            ),
                          },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "sct-file-generation-settings" },
                            [
                              _c("div", { staticClass: "generation-row" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "custom-control custom-radio",
                                  },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.sctFileGenerationMode,
                                          expression: "sctFileGenerationMode",
                                        },
                                      ],
                                      staticClass: "custom-control-input",
                                      attrs: {
                                        id: "sctFileGenerationManual",
                                        type: "radio",
                                        name: "sctFileGenerationRadio",
                                        value: "manual",
                                        disabled: !_vm.doesEdit,
                                      },
                                      domProps: {
                                        checked: _vm._q(
                                          _vm.sctFileGenerationMode,
                                          "manual"
                                        ),
                                      },
                                      on: {
                                        change: function ($event) {
                                          _vm.sctFileGenerationMode = "manual"
                                        },
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "label",
                                      {
                                        staticClass: "custom-control-label",
                                        attrs: {
                                          for: "sctFileGenerationManual",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                      " +
                                            _vm._s(
                                              _vm.$t(
                                                "mandate.remittance_generation.manual_trigger"
                                              )
                                            ) +
                                            "\n                    "
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "generation-row interval-row" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "custom-control custom-radio",
                                    },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.sctFileGenerationMode,
                                            expression: "sctFileGenerationMode",
                                          },
                                        ],
                                        staticClass: "custom-control-input",
                                        attrs: {
                                          id: "sctFileGenerationInterval",
                                          type: "radio",
                                          name: "sctFileGenerationRadio",
                                          value: "auto",
                                          disabled: !_vm.doesEdit,
                                        },
                                        domProps: {
                                          checked: _vm._q(
                                            _vm.sctFileGenerationMode,
                                            "auto"
                                          ),
                                        },
                                        on: {
                                          change: function ($event) {
                                            _vm.sctFileGenerationMode = "auto"
                                          },
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "label",
                                        {
                                          staticClass: "custom-control-label",
                                          attrs: {
                                            for: "sctFileGenerationInterval",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                      " +
                                              _vm._s(
                                                _vm.$t(
                                                  "mandate.remittance_generation.within_interval"
                                                )
                                              ) +
                                              "\n                    "
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "interval-selects" },
                                    [
                                      _c(
                                        "select",
                                        {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value:
                                                _vm.sctFileGenerationFrequency,
                                              expression:
                                                "sctFileGenerationFrequency",
                                            },
                                          ],
                                          staticClass:
                                            "form-control form-control-sm",
                                          attrs: {
                                            disabled:
                                              !_vm.doesEdit ||
                                              _vm.sctFileGenerationMode !==
                                                "auto",
                                          },
                                          on: {
                                            change: function ($event) {
                                              var $$selectedVal =
                                                Array.prototype.filter
                                                  .call(
                                                    $event.target.options,
                                                    function (o) {
                                                      return o.selected
                                                    }
                                                  )
                                                  .map(function (o) {
                                                    var val =
                                                      "_value" in o
                                                        ? o._value
                                                        : o.value
                                                    return val
                                                  })
                                              _vm.sctFileGenerationFrequency =
                                                $event.target.multiple
                                                  ? $$selectedVal
                                                  : $$selectedVal[0]
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "option",
                                            { attrs: { value: "daily" } },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "mandate.remittance_generation.daily"
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "option",
                                            { attrs: { value: "weekly" } },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "mandate.remittance_generation.weekly"
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "select",
                                        {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.sctFileGenerationTime,
                                              expression:
                                                "sctFileGenerationTime",
                                            },
                                          ],
                                          staticClass:
                                            "form-control form-control-sm space",
                                          attrs: {
                                            disabled:
                                              !_vm.doesEdit ||
                                              _vm.sctFileGenerationMode !==
                                                "auto",
                                          },
                                          on: {
                                            change: function ($event) {
                                              var $$selectedVal =
                                                Array.prototype.filter
                                                  .call(
                                                    $event.target.options,
                                                    function (o) {
                                                      return o.selected
                                                    }
                                                  )
                                                  .map(function (o) {
                                                    var val =
                                                      "_value" in o
                                                        ? o._value
                                                        : o.value
                                                    return val
                                                  })
                                              _vm.sctFileGenerationTime = $event
                                                .target.multiple
                                                ? $$selectedVal
                                                : $$selectedVal[0]
                                            },
                                          },
                                        },
                                        _vm._l(24, function (hour) {
                                          return _c(
                                            "option",
                                            {
                                              key:
                                                "sct-file-generation-" +
                                                (hour - 1),
                                              domProps: {
                                                value:
                                                  String(hour - 1).padStart(
                                                    2,
                                                    "0"
                                                  ) +
                                                  "-" +
                                                  String(hour % 24).padStart(
                                                    2,
                                                    "0"
                                                  ),
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                        " +
                                                  _vm._s(hour - 1) +
                                                  "h - " +
                                                  _vm._s(hour % 24) +
                                                  "h\n                      "
                                              ),
                                            ]
                                          )
                                        }),
                                        0
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "form-accordion",
                        {
                          attrs: {
                            open: "",
                            title: _vm.$t(
                              "mandate.remittance_generation.expiring_extraction"
                            ),
                          },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "expiring-mandates-settings" },
                            [
                              _c(
                                "div",
                                { staticClass: "generation-row interval-row" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "custom-control custom-radio",
                                    },
                                    [
                                      _c(
                                        "label",
                                        {
                                          attrs: {
                                            for: "expiringMandatesType",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n        " +
                                              _vm._s(
                                                _vm.$t(
                                                  "mandate.remittance_generation.type"
                                                )
                                              ) +
                                              "\n      "
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "interval-selects-type" },
                                    [
                                      _c(
                                        "select",
                                        {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.expiringMandatesType,
                                              expression:
                                                "expiringMandatesType",
                                            },
                                          ],
                                          staticClass:
                                            "form-control form-control-sm",
                                          attrs: {
                                            id: "expiringMandatesType",
                                            disabled: !_vm.doesEdit,
                                          },
                                          on: {
                                            change: function ($event) {
                                              var $$selectedVal =
                                                Array.prototype.filter
                                                  .call(
                                                    $event.target.options,
                                                    function (o) {
                                                      return o.selected
                                                    }
                                                  )
                                                  .map(function (o) {
                                                    var val =
                                                      "_value" in o
                                                        ? o._value
                                                        : o.value
                                                    return val
                                                  })
                                              _vm.expiringMandatesType = $event
                                                .target.multiple
                                                ? $$selectedVal
                                                : $$selectedVal[0]
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "option",
                                            { attrs: { value: "manual" } },
                                            [
                                              _vm._v(
                                                "\n          " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "mandate.remittance_generation.none"
                                                    )
                                                  ) +
                                                  "\n        "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "option",
                                            { attrs: { value: "ftp" } },
                                            [
                                              _vm._v(
                                                "\n          " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "mandate.remittance_generation.ftp"
                                                    )
                                                  ) +
                                                  "\n        "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    {
                      staticClass:
                        "accordionForm form-group mt-3 justify-content-end no-gutters",
                    },
                    [
                      _c(
                        "b-button",
                        {
                          staticClass: "btnFilter_2",
                          on: {
                            click: function ($event) {
                              return _vm.createCompanyv2()
                            },
                          },
                        },
                        [
                          _c("i", { staticClass: "fa-light fa-save" }),
                          _vm._v(" "),
                          _c("span", [_vm._v(_vm._s(_vm.$t("common.sve")))]),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }